module.exports = __webpack_public_path__ + "static/media/head-cogs-komatsu-blue@3x.bd4f4458.png";